import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const epguErrorUrl = `${SERVER_API}/issues/epgu/errors`;

export const EPGU_ERROR = {
  LIST: {
    method: 'GET',
    url: epguErrorUrl,
  } as IEndpointData,
  GET(id: number) {
    return {
      method: 'GET',
      url: `${epguErrorUrl}/${id.toString()}`,
    } as IEndpointData;
  },
  REJECT: {
    method: 'POST',
    url: `${epguErrorUrl}/reject`,
  } as IEndpointData,
};
